import PhoneLink from "../common/links/PhoneLink";
import IconPhone from "../Icons/IconPhone";
import { cn } from "@/lib/utils";

interface ContactLinkProps {
  phoneNumber: string;
  className?: string;
  iconFill?: string;
  dir?: "ltr" | "rtl" | "auto";
  showIcon?: boolean;
}

export const ContactLink = ({
  phoneNumber = "+97143772503",
  className,
  iconFill = "currentColor",
  dir = "ltr",
  showIcon = true,
}: ContactLinkProps) => {
  return (
    <div dir={dir} className="inline-flex">
      <PhoneLink
        phoneNumber={phoneNumber}
        trackingSource="contact_link"
        linkClassNames={cn("flex items-center font-medium hover:underline", className)}
        buttonClassNames={cn("flex items-center font-medium hover:underline", className)}
      >
        {showIcon && <IconPhone fill={iconFill} />}
        <span className={cn(showIcon && "ml-2")}>{phoneNumber}</span>
      </PhoneLink>
    </div>
  );
};
